// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3V-ZL","errorLogs":"styles_errorLogs__30o2I"};